import { render, staticRenderFns } from "./NeedDetails.vue?vue&type=template&id=10c42fa4&scoped=true&"
import script from "./NeedDetails.vue?vue&type=script&lang=js&"
export * from "./NeedDetails.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./NeedDetails.vue?vue&type=style&index=0&id=10c42fa4&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10c42fa4",
  null
  ,true
)

export default component.exports